class SectionCollectionFeature extends HTMLElement {
  constructor() {
    super();
    this.inner = this.querySelector("[data-inner]");
    this.mainMedia = this.querySelector("[data-main-media]");
    this.rightContent = this.querySelector("[data-right-content]");
    this.sectionHeader = this.querySelector(".section__header");
    
    this.carouselWrap = this.querySelector(".collection-feature__carousel");

    this.carousel = this.querySelector("[data-carousel]");
    this.layout = this.dataset.layout
    this.init();
  }

  init() {
    this.initOptions();
    this.initCarousel();
    if (this.mainMedia) {
      this.calcMediaHeight();
    }

    window.addEventListener('resize', () => {
      if (this.mainMedia) {
        this.calcMediaHeight();
      }
    })
  }

  initOptions() {
    this.options = {
      navigation: {
        nextEl: this.carousel.querySelector('.swiper-button-next'),
        prevEl: this.carousel.querySelector('.swiper-button-prev')
      },
      freeMode: true,
      centerInsufficientSlides: true,
      slidesOffsetAfter: 20,
      breakpoints: {
        1600: {
          slidesPerView: 2.8,
          spaceBetween : 40,
          slidesOffsetAfter: 60,
        },
        1400: {
          slidesPerView: 2.8,
          spaceBetween : 40,
          slidesOffsetAfter: 40,
        },
        1008: {
          slidesPerView: 2.8,
          spaceBetween : 20,
          slidesOffsetBefore: 0
        },
        641: {
          slidesPerView: 2.3,
          spaceBetween : 30,
          slidesOffsetBefore: 40
        },
        321: {
          slidesPerView: 2,
          spaceBetween : 10,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },
        0: {
          slidesPerView: 1,
          spaceBetween : 10,
          slidesOffsetBefore: 0
        },
      }
    }
  }

  initCarousel() {
    const breakpoint = window.matchMedia(`(min-width: 1008px)`);
    if (this.layout == 'overlay') {
      if (!breakpoint.matches) {
        const swiper = new Swiper(this.carousel, this.options);
      } else {

      }
    } else {
      const swiper = new Swiper(this.carousel, this.options);
    }
  }

  calcMediaHeight() {
    const breakpoint = window.matchMedia(`(min-width: 1008px)`);
    if (breakpoint.matches) {
      setTimeout(() => {
        const height = this.mainMedia.offsetHeight
        const headerHeight = this.sectionHeader.offsetHeight
        let offset = 30;
        if (window.innerWidth >= 1440) {
          offset = 80
        }

        this.carouselWrap.style.maxHeight = `${height-headerHeight-offset}px`;
      }, 100)
    }
  }

  calcRightCarouselHeight() {

  }
}

if (!customElements.get("section-collection-feature")) {
  customElements.define("section-collection-feature", SectionCollectionFeature);
}
